<div class="modal-header">
    <div class="modal-title">Low Value Notice</div>
    <button id="low-value-notice-close" type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <p class="text-center">
        The input revenue values are unusually low which may suggest abbreviation. <br />
        Valzy does NOT abbreviate numbers. If your values are in thousands please write them out fully for
        an accurate valuation. <em>(Eg. $1 Million should be input $1,000,000)</em>.
    </p>
</div>

<div class="modal-footer justify-content-between">
  <label class="checkbox large m-0">
    <input class="checkbox__input" type='checkbox' id="skipLowValue"
           [(ngModel)]="skipLowValueWarning"
           name="skipLowValue" #skipLowValue="ngModel" />
    <div class="checkbox__data">
      <div class="checkbox__indicator"></div>
      <p class="checkbox__text">
        Do not show this again for this Report.
      </p>
    </div>
  </label>

  <button id="low-value-notice-ok-btn" type="button" class="button secondary__button large__button" (click)="onClose()">Ok</button>
</div>
